module.exports = __webpack_public_path__ + "img/hook_KITO_HTL_2.2f3fdaea.png";